import React, { Suspense } from 'react';

import PriorityPlaylistLoader from 'components/data-containers/PlaylistPriorityActivity/SkeletonLoader';

const PriorityPlaylistActivity = React.lazy(
  () => import('components/data-containers/PlaylistPriorityActivity')
);

const PriorityPlaylist: React.FC = () => {
  return (
    <div>
      <Suspense
        fallback={<PriorityPlaylistLoader title="Priority Playlist Activity" />}
      >
        <PriorityPlaylistActivity isPriorityPlaylistPage />
      </Suspense>
    </div>
  );
};

export default PriorityPlaylist;
